<app-view-title Title="{{ 'Intellitrailer.Booking.LocationList.TitleLocation' | translate : 'Locations' }}" [isSplitColor]="true"></app-view-title>
<view-content>
  <app-search (valueChange)="filterLocations($event)"></app-search>
  @if(filteredLocations)
  {
  <div *ngFor="let loc of filteredLocations">
    <div class="row m-3" (click)="selectLocation(loc)">
      <div class="col-2">
        <img class="location-logo" [src]="'/Styles/' + appSettings.settings.theme + '/LogoDark.png'" />
      </div>
      <div class="col-8">
        <b class="m-0">{{ loc.Name }}</b><br/>
        {{loc.Address}}
      </div>
      @if(loc.Distance){
      <div class="col-2">{{ loc.Distance | number : '0.1-1' | transliterate }}km</div>
      }
    </div>
  </div>
  }
</view-content>
<view-actions>
  <button type="button" mat-raised-button (click)="showMap()">{{ 'Intellitrailer.Booking.LocationList.btnMap' | translate : 'Show Map' }}</button>
</view-actions>
